import $ from 'jquery';

import { standardAjaxPost } from 'stdjs/standard-ajax';

$(document).ready(function(){

    $("#FORGOT_BACK").click(function(e){
        e.preventDefault();
        location.href = signInUrl;        
        return false;
    });

    $("#USER10_EMAL").keypress(function(e){
        if (e.keyCode === 13){
            e.preventDefault();
            $("#FORGOT_SUBMIT").click();
            return false;
        }                
    });    
});

